import React from "react";
import PageHeader from "~/common/components/PageHeader";
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import darkInitImg from "~/assets/img/dark-init-img.png";
import { useTranslation } from "react-i18next";

const ApplyForm = () => {
	const { t } = useTranslation();

	const headerButtons = [
		<button type="button" className="btn__solid" color="primary">
			{t("pages.apply.ApplyForm.createForm")}
		</button>,
	];
	return (
		<NavbarAndSidebarLayout menu={["apply", "form"]} type={"main"}>
			<PageHeader buttonList={headerButtons} />
			<div className="page-init">
				<p className="main">{t("pages.apply.ApplyForm.noFormMessage")}</p>
				<p className="sub">{t("pages.apply.ApplyForm.noFormSubMessage")}</p>
				<img src={darkInitImg} alt={t("pages.apply.ApplyForm.initImg")} />
				{/*<img src={lightInitImg} alt={t("pages.apply.ApplyForm.initImg")} />*/}
			</div>
		</NavbarAndSidebarLayout>
	);
};

export default ApplyForm;
